import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { getCustomClasses, getViewHeight, TableAction } from './table.const';
import { BaseComponent } from '../base.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import * as _ from 'lodash';

@Component({
  selector: 'app-table-component',
  templateUrl: './table-component.component.html',
  styleUrls: ['./table-component.component.css'],
})
export class TableComponentComponent extends BaseComponent implements OnChanges {
  @Input() theadStyles: any = {};
  @Input() data: any[] = [];
  @Input() lstChecked: any[] = [];
  @Input() columns: {
    title: string;
    key: string;
    display: boolean;
    allowSort: boolean;
    classes: string;
    field?: string;
  }[] = [];
  @Input() isLoading = false;
  @Input() keyData = 'id';
  @Input() title = 'Danh sách dữ liệu';
  @Input() totalString = '';
  @Input() totalItem: any = 0;
  @Input() totalPage: any = 1;
  @Input() currentPage: any = 1;
  @Input() pageSize: any = 10;
  @Input() maxHeight: any = 90;
  @Input() customBtnAction: {
    action: string;
    title: string;
    display: boolean;
    classes?: string;
    content?: any;
  }[] = [];

  @Input() add = false;
  @Input() view = false;
  @Input() edit = false;
  @Input() delete = false;
  @Input() config = false;
  @Input() lock = false;
  @Input() signIn = false;
  @Input() user = false;
  @Input() params = false;
  @Input() activeAction = false;
  @Input() viewAction = false;
  @Input() showHeader = false;
  @Input() showCheckCol = true;
  @Input() showLimit = false;
  @Input() showOptionView = false;
  @Input() haveLoading = false;

  @Output() action = new EventEmitter<{ type: any; item?: any }>();
  @Output() customAction = new EventEmitter<{ type: any; item?: any }>();
  @Output() checkRow = new EventEmitter<{ type: any; id?: any }>();
  @Output() clickHeader = new EventEmitter<{ key: any; sort: any }>();
  @Output() clickRow = new EventEmitter<{ item: any }>();
  @Output() clickField = new EventEmitter<{ key: any; item: any }>();
  @Output() hoverRow = new EventEmitter<{ item: any }>();
  @Output() goPage = new EventEmitter<{ page: any }>();
  @Output() setPage = new EventEmitter<{ page: any }>();
  @Output() changeLimit = new EventEmitter<{ limit: any }>();
  @Output() changeExportFields = new EventEmitter<{ fields: any }>();

  public displayColumns: {
    title: string;
    key: string;
    display: boolean;
    allowSort: boolean;
    classes: string;
    field?: string;
  }[] = [];

  public exportFields: any = [];
  public sort = 'desc';
  public readonly TableAction = TableAction;

  public readonly getCustomClasses = getCustomClasses;
  public readonly _ = _;
  public readonly getViewHeight = getViewHeight;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService
  ) {
    super(changeDetector, toastr, modalService);
  }

  ngOnInit() {
    this.displayColumns = [];
    this.columns.forEach(column => {
      if (column.display) {
        this.displayColumns.push(column);
      }
    });
  }

  onAction(type: any = TableAction.edit, item?: any) {
    this.action.emit({ type: type, item: item });
  }

  onCheckAllRow() {
    this.checkRow.emit({ type: 'all' });
  }

  onCheckRow(id: any) {
    this.checkRow.emit({ type: 'row', id: id });
  }

  onClickRow(item: any) {
    this.clickRow.emit({ item: item });
  }

  onClickField(key, item: any) {
    this.clickField.emit({ key: key, item: item });
  }

  onClickHeader(key: any) {
    if (this.sort === 'desc') {
      this.sort = 'asc';
    } else {
      this.sort = 'desc';
    }
    this.clickHeader.emit({ key: key, sort: this.sort });
  }

  onHoverRow(item: any) {
    this.hoverRow.emit({ item: item });
  }

  onGoPage(page: any) {
    this.goPage.emit({ page: page });
  }

  onSetPage(page: any) {
    this.setPage.emit({ page: page });
  }

  onChangeLimit(limit: any) {
    const value = limit.target.value;
    this.changeLimit.emit({ limit: value });
  }

  onActiveAction(bool, item) {
    this.onAction(TableAction.active, { status: bool, _id: item._id });
  }

  onCustomAction(type, item) {
    this.customAction.emit({ type: type, item: item });
  }

  changedOptionView(data) {
    this.columns = data;
    this.displayColumns = [];
    this.columns.forEach(column => {
      if (column.display) {
        this.displayColumns.push(column);
      }
    });
    this.exportFields = this.displayColumns.filter(f => f.display === true).map(f => f.field);
    this.changeExportFields.emit({ fields: this.exportFields });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.columns) {
      this.displayColumns = [];
      this.columns.forEach(column => {
        if (column.display) {
          this.displayColumns.push(column);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/table-component/table-component.component.ts